import { ReactNode } from 'react';
import l from '../../../../../lang';
import InputSearch from '../../../../common/input-search';
import MultiSelect from '../../../../common/multi-select';
import { useAvailableCountries } from '../../../../../hooks/use-available-countries';
import { Filters } from '../../../../../store/interfaces';

interface PayoutContactsFilterProps {
  loading: boolean;
  appliedFilters: Filters;
  changeFilters: (filters: Filters) => void;
  downloadButton: ReactNode;
}

const PayoutContactsFilter = ({ loading, appliedFilters, changeFilters, downloadButton }: PayoutContactsFilterProps) => {
  const allCountries = useAvailableCountries();
  const countries = allCountries.map(countryCode => ({
    id: countryCode,
    name: l(`countryCode.${countryCode}`),
  }));
  const selectedCountries = appliedFilters.country
    ? appliedFilters.country
        .split(',')
        .map(countryCode => countries.find(country => country.id === countryCode))
        .filter((country): country is { id: string; name: string } => Boolean(country))
    : [];

  return (
    <div className="payout_contacts_filter">
      <div className="payout_contacts_filter__search">
        <InputSearch
          value={appliedFilters.search}
          placeholder={l('payoutContacts.search.placeholder')}
          showSearchType={false}
          isLoading={loading}
          onSearch={(_type, value) => changeFilters({ ...appliedFilters, search: value })}
        />
      </div>
      <div className="payout_contacts_filter__country">
        <MultiSelect
          value={selectedCountries}
          name="payout-contacts-country"
          size="sm"
          label={l('payoutContacts.column.country')}
          titleOptions={l('payoutContacts.column.country')}
          placeholderSearch={l('searchCountries.label')}
          disabled={loading}
          onChange={(country: string) => changeFilters({ ...appliedFilters, country })}
          options={countries}
          withApplyBtn
          withSearch
          maxHeightOptions={400}
          withoutMarginTop
        />
      </div>
      <div className="payout_contacts_filter__download">{downloadButton}</div>
    </div>
  );
};

export default PayoutContactsFilter;
